import { defineStore } from 'pinia';
import { i18n, SupportedLocales, type Locale } from '@/i18n';

const STORAGE_KEY = 'cavicode-network.locale';

/**
 * Локаль UI. Сохраняется в localStorage; при первом заходе пробует
 * угадать по navigator.language. Дефолт — 'ru' (большинство пользователей
 * проекта говорят по-русски).
 */
export const useLocaleStore = defineStore('locale', {
    state: () => ({ current: detect() as Locale }),
    actions: {
        set(lang: Locale) {
            this.current = lang;
            try {
                localStorage.setItem(STORAGE_KEY, lang);
            } catch {
                /* noop */
            }
            applyToVue(lang);
        },
        bootstrap() {
            applyToVue(this.current);
        }
    }
});

function detect(): Locale {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved && (SupportedLocales as readonly string[]).includes(saved)) {
            return saved as Locale;
        }
    } catch {
        /* noop */
    }
    if (typeof navigator !== 'undefined') {
        const lang = (navigator.language || '').toLowerCase();
        if (lang.startsWith('ru')) return 'ru';
    }
    return 'ru';
}

function applyToVue(lang: Locale) {
    // i18n.global.locale в legacy:false — это WritableComputedRef<string>.
    (i18n.global.locale as { value: string }).value = lang;
    if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('lang', lang);
    }
}